export const STATUS_PAUTA_BLOQUEADA = 0
export const STATUS_PAUTA_LIBERADA = 1
export const STATUS_PAUTA_ENCERRADA = 2

export const getStatusClassName = (status: number = STATUS_PAUTA_BLOQUEADA) => {
  switch (status) {
    case STATUS_PAUTA_ENCERRADA:
      return 'encerrada'
    case STATUS_PAUTA_LIBERADA:
      return 'liberada'
    case STATUS_PAUTA_BLOQUEADA:
    default:
      return 'bloqueada'
  }
}
export const STATUS_PAUTA = [
  STATUS_PAUTA_BLOQUEADA,
  STATUS_PAUTA_LIBERADA,
  STATUS_PAUTA_ENCERRADA
]

export type PautaStatusType = typeof STATUS_PAUTA[number]
